import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicContractVisitsService {
  constructor(private http: PublicHttpClientService) {}

  put(contract_visit: any): Observable<any> {
    return this.http
      .put(`/api/public/contract_visits/${contract_visit.id}`, contract_visit)
      .pipe(tap((_) => console.log("PublicContractVisitsService.put: Ok.")));
  }
}
